import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Chart from "react-google-charts";
import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

const styles = {
  card: {
    minWidth: 275,
    width: 'auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 18,
  },
  pos: {
    marginBottom: 12,
  },
};

function ForecastChart(props) {

  const { waveStationForecast, classes, forecast, chartTitle, flagShowOnlyToday, hAxisFormat } = props; 
  const [ waveData, setWaveData ] = useState([]);
  const [ loadingForecastFlag, setLoadingForecastFlag] = useState(true)
  let dates_arr = []
 
  //console.log(waveStationForecast);

  const dataFormatting = () => {
      
        if (!forecast || forecast.length ===0) {
            console.log("wave forecast for this location not found")
            setLoadingForecastFlag(false)
            return
        }

        dates_arr = forecast.map((element, index) => {

            let today = new Date().getDate()

            if (index===0) {
                return ["Element", "Wave Height", { role: "style" }];
            }
            else {
                var d = new Date(element['date']);

                if ((flagShowOnlyToday && d.getDate()===today) ||
                    (!flagShowOnlyToday)) {

                    let barColor = ''

                    const OPACTICY='0.7'
                    const FILL_COLOR='#3cbbe8'

                    barColor = 'fill-color: '+ FILL_COLOR + '; fill-opacity:'+ OPACTICY
                
                    if (d.getDate()===today)
                        barColor = 'fill-color: '+ 'red' + '; fill-opacity:'+ OPACTICY

                    return [new Date(d.getFullYear(),d.getMonth(),d.getDate(),d.getHours(),d.getMinutes(),d.getSeconds()),
                    + element['wave_height'],
                    barColor];
                    }
            }
        }).filter(e => e !== undefined)
  }

  useEffect(() => {
      dataFormatting();
      setWaveData(dates_arr);
  }, [forecast])

    return (  
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title}>
          {chartTitle}
          </Typography>
            <div className="App">
            {(waveData.length > 0) ? (
                  <Chart
                    chartType="ColumnChart"
                    /* width="100%" */
                    height="200px"
                    data={waveData}
                    options={
                        {title: "Wave Height (ft)", 
                        subtitle: "Subtitle here...",
                        /*   bar: {groupWidth: "100%"}, */
                        legend: { position: "none" },
                        /* width: '800px', */
                        chartArea:{left:30,top:20,width:'95%',height:'80%'},
                        /*     gridlines: { multiple: 1}  */
                        /*    hAxis: { gridlines: { units: {interval: 1000}}} */
                        /*  hAxis:  {viewWindow:{ 
                                  min: [02, 18, 2023], 
                                  max: [02, 23, 2023]
                        } } */
                        hAxis: {
                          format: hAxisFormat,
                          gridlines: {count: 8},
                          textPosition: 'out',
                          //textStyle: { color: '#0070f3' },
                          slantedText: false

                        },
                        gridlines: {
                          units: {
                            years: {format: [/*format strings here*/]},
                            months: {format: [/*format strings here*/]},
                            days: {format: [/*format strings here*/]},
                            hours: {format: [/*format strings here*/]},
                            minutes: {format: [/*format strings here*/]},
                            seconds: {format: [/*format strings here*/]},
                            milliseconds: {format: [/*format strings here*/]},
                          }
                        }
                      }
                    }
                  />
                ) : (
                    <div>
                        { (loadingForecastFlag) ? (
                        <Skeleton variant="rectangular" width={'100%'} height={200} />
                        ) : (
                            <span style={{ color: "grey", fontSize: 12 }}>Forecast not found for this location</span>
                        )}
                    </div>
                )}
            </div>
            <div style={{ color: "green", maxInlineSize:"200px", fontSize: 10 }}> Station : {waveStationForecast} </div>
        </CardContent>
      </Card>
  );
}

ForecastChart.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ForecastChart);


